import { render } from "./SolutionRelation.vue?vue&type=template&id=d8c55d88"
import script from "./SolutionRelation.vue?vue&type=script&lang=js"
export * from "./SolutionRelation.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/h5/ai/solution/SolutionRelation.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "d8c55d88"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('d8c55d88', __exports__)) {
    api.reload('d8c55d88', __exports__)
  }
  
  module.hot.accept("./SolutionRelation.vue?vue&type=template&id=d8c55d88", () => {
    api.rerender('d8c55d88', render)
  })

}


export default __exports__